import * as React from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import borders from 'assets/theme/base/borders';
import { useEffect, useState } from 'react';
import { RowDataType, TableMetaData } from 'types/common/common';
import { StyledTableRow } from 'component/tabel-pagination-style';
import dayjs from 'dayjs';
import { API_ENDPOINT_URL } from 'constant';
import { TeamDetailsResponse } from 'types/team/team';

const defaultTableStaffDataList: TableMetaData[] = [
    {
        key: 'img',
        position: 1,
        title: 'Team Avatar',
        isSortable: false,
    },
    {
        key: 'nickname',
        position: 2,
        title: ' Team User Name',
        isSortable: false,
    },

    {
        key: 'memberType',
        position: 3,
        title: 'Member Type',
        isSortable: false,
    },

    {
        key: 'status',
        position: 4,
        title: 'Status',
        isSortable: false,
    },

    {
        key: 'requestDate',
        position: 5,
        title: 'Request Date',
        isSortable: false,
        type: 'date',
        format: 'DD.MM.YYYY HH:mm',
    },

    {
        key: 'createdDate',
        position: 6,
        title: 'Creation Data',
        isSortable: false,
        type: 'date',
        format: 'DD.MM.YYYY HH:mm',
    },

    {
        key: 'deletedDate',
        position: 7,
        title: 'Deleted Date',
        isSortable: false,
        type: 'date',
        format: 'DD.MM.YYYY HH:mm',
    },
];

interface Props {
    data?: TeamDetailsResponse;
}

const TeamUsers: React.FC<Props> = (props: Props) => {
    const { data } = props;
    const [tableMetaDataList] = useState<TableMetaData[]>(
        defaultTableStaffDataList,
    );
    const [tableData, setTableData] = useState<RowDataType[]>([]);

    useEffect(() => {
        const tableData: RowDataType[] = !data
            ? []
            : data.teamMemberList.map((fullInfo: any) => {
                  return {
                      ...fullInfo,
                      img: (
                          <>
                              {fullInfo?.id ? (
                                  <Box
                                      component="img"
                                      src={`${API_ENDPOINT_URL}/avatar/file/${fullInfo.avatarId}`}
                                      alt=""
                                      sx={{
                                          width: 60,
                                          height: 60,
                                          objectFit: 'cover',
                                          objectPosition: 'top',
                                          borderRadius:
                                              borders.borderRadius.section,
                                      }}
                                  />
                              ) : (
                                  <Typography variant="h5">-</Typography>
                              )}
                          </>
                      ),
                      rowComponent: StyledTableRow,
                  };
              });
        setTableData(tableData);
    }, [data]);

    return (
        <Box
            bgcolor={colors.secondary.light}
            borderRadius={borders.borderRadius.md}
            mt={pxToRem(7)}
        >
            <TableContainer
                sx={{
                    minHeight: pxToRem(400),
                    maxHeight: pxToRem(600),
                    overflowY: 'auto',
                }}
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            {tableMetaDataList.map((col) => (
                                <TableCell key={col.key}>{col.title}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData.map((row, idx) => (
                            <StyledTableRow key={idx} data={row}>
                                {tableMetaDataList.map((col) => (
                                    <TableCell key={col.key}>
                                        {col.key === 'createdDate' &&
                                        row[col.key]
                                            ? dayjs(row[col.key]).format(
                                                  'DD.MM.YYYY',
                                              )
                                            : row[col.key]}
                                    </TableCell>
                                ))}
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};
export default TeamUsers;
